module.exports = __webpack_public_path__ + "static/img/cover.1e3d3110.png";